import styled from 'styled-components'

import { StyledDivider } from 'shared/ui/Divider/Divider.styled'
import { SCROLLBAR_WIDTH } from 'widgets/Layout/constants'

export const StyledLineDivider = styled(StyledDivider)`
  padding: 2px 16px;
  padding-right: calc(16px - ${SCROLLBAR_WIDTH});
`
